import {
  ComedyIcon,
  PuppeteerIcon,
  ActionIcon,
  MusicalIcon,
  CoupleIcon,
  FantasyIcon,
  SuspenseIcon,
  DramaIcon,
  BallotIcon,
  ClapIcon,
  PeopleIcon
} from "../components/icons";

export const memberCategoriesChoice = [
  { id: 500, name: "Comedy", Icon: ComedyIcon },
  { id: 200, name: "Animations", Icon: PuppeteerIcon },
  { id: 100, name: "Exaggerate", Icon: ActionIcon },
  { id: 700, name: "Musical", Icon: MusicalIcon },
  { id: 600, name: "Relatable", Icon: PeopleIcon },
  { id: 50, name: "Surreal", Icon: FantasyIcon },
  { id: 10, name: "Impersonations", Icon: SuspenseIcon },
  { id: 330, name: "Drama", Icon: DramaIcon },
];

export const categories = [
  {
    id: 600,
    title: "Relatables",
    description: "(How relatable?)",
  },
  {
    id: 100,
    title: "Exaggerated",
    description: "(How extreme?)",
  },
  {
    id: 10,
    title: "Impersonations",
    description: "(Score based on impersonation of character(s))",
  },
  {
    id: 700,
    title: "Musicals",
    description: "(How emotional/catchy?)",
  },
  {
    id: 330,
    title: "Dramas",
    description: "(How believable?)",
  },
  {
    id: 50,
    title: "Surreal",
    description: "(How imaginative?)",
  },
  {
    id: 200,
    title: "Animations",
    description: "(How animated?)",
  },
  {
    id: 500,
    title: "Comedies",
    description: "(How funny?)",
  },
];

export const channelToCategoryMap = {
  1: 500, // Comedy
  2: 200, // Animations
  3: 100, // Exaggerate
  4: 700, // Musical
  5: 600, // Relatable
  6: 50, // Surreal
  7: 10, // Impersonation(s)
  8: 330, // Drama
};

export const channels = [
  { id: 1, name: "Comedies", Icon: ComedyIcon },
  { id: 2, name: "Animations", Icon: PuppeteerIcon },
  { id: 3, name: "Exaggerations", Icon: ActionIcon },
  { id: 4, name: "Musicals", Icon: MusicalIcon },
  { id: 5, name: "Relatables", Icon: CoupleIcon },
  { id: 6, name: "Surreal", Icon: FantasyIcon },
  { id: 7, name: "Impersonations", Icon: SuspenseIcon },
  { id: 8, name: "Dramas", Icon: DramaIcon },
];



export const channelsFilters = [
  { id: 500, name: "Comedies", Icon: ComedyIcon },
  { id: 200, name: "Animations", Icon: PuppeteerIcon },
  { id: 100, name: "Exaggerate", Icon: ActionIcon },
  { id: 700, name: "Musicals", Icon: MusicalIcon },
  { id: 600, name: "Relatables", Icon: CoupleIcon },
  { id: 50, name: "Surreal", Icon: FantasyIcon },
  { id: 10, name: "Impersonations", Icon: SuspenseIcon },
  { id: 330, name: "Dramas", Icon: DramaIcon },
];

export const skitsRankingsFilters = [
  { id: 1, name: "claps", Icon: ClapIcon },
  { id: 2, name: "ratings", Icon: BallotIcon },
]
